var map = {
	"./goldcoin/task-detail-arrow.png": 25399,
	"./memetown/task-detail-arrow.png": 11632,
	"./reflection/task-detail-arrow.png": 14393,
	"./tapcoin/task-detail-arrow.png": 50056
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 76824;